<template>
  <div style="padding: 0 24px">
    <ScanQuery @onQuery="queryCall" ph="输入快递单号">
      <div slot="customize">
        <el-select v-model="regionCode">
          <el-option
            v-for="item in regionList"
            :key="item.id"
            :label="item.regionName"
            :value="item.regionCode"
          >
          </el-option>
        </el-select>

        <el-button type="primary" :disabled="true" style="margin-left: 10px"
          >总数：{{ dataTotal }}</el-button
        >
        <el-button type="primary" @click="allSign" :disabled="signFlag">一键签收</el-button>
      </div>
    </ScanQuery>
    <WmsTable
      :columns="columns"
      :dataSource="dataSource"
      @pageChange="pageChangeCall" :isPagination="query" 
    >
      <template slot="productImgAction" slot-scope="{ text, record, index }">
        <ImgView :src="text" width="120" height="120"></ImgView>
      </template>
      <template slot="targetOrgAction">
        <el-select value="1" placeholder="请选择" disabled>
          <el-option label="成品区" value="1"> </el-option>
        </el-select>
      </template>
    </WmsTable>
  </div>
</template>

<script>
import ScanQuery from "@/components/ScanQuery";
import WmsTable from "@/components/WmsTable";
import { columns, testDataSource } from "./transferConfirmData";
import IptNumber from "@/components/IptNumber";
import ImgView from "@/components/ImgView";
import { batchSigh, getPkgByLogisticsNo } from "@/apis/outDomestic";
import { getRegionList } from "@/apis/configure";
export default {
  title: "仓库调拨确认", // 仓库转换
  name: "transferConfirm",
  components: {
    ScanQuery,
    IptNumber,
    WmsTable,
    ImgView,
  },
  data() {
    return {
      columns,
      query: {
        code: "",
        current: 1,
        pageSize: 10,
        total: 0,
      },
      dataSource: [],signFlag: false,
      regionCode: "",
      regionList: [],
    };
  },
  computed:{
    dataTotal:function(){
      let num = 0
      this.dataSource.forEach(item=>{
        num += item.amount
      })
      return num
    }
  },
  mounted() {
    this.getRegin();
  },
  methods: {
    queryCall: function (payload) {
      // console.log(payload)
      this.query.code = payload.code;
      this.getDataSource();
    },
    // rest(){
    //   this.query.code = '';
    //   this.getDataSource();
    // },
    pageChangeCall: function (payload) {
      this.query = {
        ...this.query,
        ...payload,
      };
    },
    allSign() {
      if (this.dataSource.length > 0) {
        let params = {
          logisticsNo: this.query.code,
          pkgCodeList: [],
          regionCode: this.regionCode,
        };
        this.dataSource.forEach((item) => {
          params.pkgCodeList.push(item.pkgCode);
        });
        batchSigh(params).then(({ code, data }) => {
          if (code === 0) {
            this.$message.success("成功");
            this.initPage()
          }
        });
      } else {
        this.$message.warning("请查询快递单号");
      }
    },
    initPage(){
      this.query = {
        code: "",
        current: 1,
        pageSize: 10,
        total: 0,
      }
      this.dataSource= []
      this.dataTotal= 0
    },
    getDataSource() {
      if (!this.query.code && this.query.code == "") {
        this.$message.warning("请填写快递单号");
      }
      let params = {
        logisticsNo: this.query.code,
      };
      getPkgByLogisticsNo(params).then(({ code, data }) => {
        if (code === 0) {
          // data.pkgList.forEach((item) => {
          //   this.dataTotal += item.amount;
          // });
          this.signFlag = data.signFlag
          this.dataSource = data.pkgList;
          this.query.total = data.total;
          this.$message.success("成功");
        }
      });
    },
    getRegin() {
      let params = {
        bindStatus: 4,
      };
      getRegionList(params).then(({ code, data }) => {
        if (code === 0) {
          this.regionList = data;
          this.regionCode = data[0].regionCode;
        }
      });
    },
  },
};
</script>

<style scoped></style>
